import React, { useState } from 'react';
import { Badge, Card, Col, Container, Dropdown, Form, ListGroup, Nav, Navbar, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FileExcel, Icon9Square, Printer, Save, Search } from 'react-bootstrap-icons';

import * as Yup from 'yup';
import { Field, Formik } from 'formik';

import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import moment from 'moment';
import XLSX from 'sheetjs-style';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import 'assets/css/table.css';
import dateformat from 'dateformat';
import common from '../../commonData';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import Axios from 'axios';
import { Button } from 'reactstrap';

function MyAwesomeTable({ rows, isLoading, setLoad }) {
    window.moment = moment;
    var ladate = new Date();
    const [gridRef, setGridRef] = useState(null);
    const [dataCogs, setCogsData] = useState([]);

    const filterValue = [
        { name: 'qtestock', operator: 'gte', type: 'number', value: 0 },
        { name: 'valeurachat', operator: 'gte', type: 'number', value: 0 },
        { name: 'valeurvente', operator: 'gte', type: 'number', value: 0 },
        { name: 'societel', operator: 'contains', type: 'string', value: '' },
        { name: 'created_at', operator: 'inrange', type: 'date', value: '' }
    ];

    function numberformat(data) {
        return new Intl.NumberFormat('de-DE').format(data);
    }

    const columns = [
        {
            name: 'id',
            header: 'Id',
            defaultVisible: false,
            defaultWidth: 80,
            type: 'number'
        },

        {
            name: 'qtestock',
            header: 'Quantité',
            defaultWidth: 90,
            type: 'number',
            textAlign: 'center',
            render: ({ value }) => numberformat(value)
        },
        {
            name: 'valeurachat',
            header: 'Valeur stock',
            defaultWidth: 140,
            type: 'number',
            textAlign: 'center',
            render: ({ value }) => numberformat(value)
        },
        {
            name: 'valeurvente',
            header: 'Valeur vente',
            defaultWidth: 140,
            type: 'number',
            textAlign: 'center',
            render: ({ value }) => numberformat(value)
        },
        {
            name: 'societel',
            header: 'Entitée',
            defaultWidth: 100,
            type: 'string',
            textAlign: 'center'
        },
        {
            name: 'created_at',
            header: 'Date sauvegarde',
            defaultWidth: 250,
            type: 'date',
            textAlign: 'center',
            dateFormat: 'DD-MM-YYYY',
            filterEditor: DateFilter,
            filterEditorProps: (props, { index }) => {
                return {
                    dateFormat: 'DD-MM-YYYY',
                    placeholder: index === 1 ? 'Date fin' : 'Date debut'
                };
            },
            render: ({ value, cellProps: { dateFormat } }) => moment(value).format(dateFormat)
        }
    ];
    const gridStyle = { minHeight: window.screen.height - 200 };

    function GetSortOrder(prop) {
        return function (a, b) {
            if (a[prop] < b[prop]) {
                return 1;
            } else if (a[prop] > b[prop]) {
                return -1;
            }
            return 0;
        };
    }
    async function printListe() {
        // setLoad(true)
        const data = [];
        var tablo = [];
        tablo = gridRef.current.data.sort(GetSortOrder('created_at'));
        tablo.forEach((row, index) => {
            data.push([
                { content: index + 1 },
                { content: numberformat(row.qtestock) },
                { content: numberformat(row.valeurachat) },
                { content: numberformat(row.valeurvente) },
                { content: row.created_at ? dateformat(row.created_at, 'dd-mm-yyyy HH:MM') : 'Néant' }
            ]);
        });
        const doc = new jsPDF();
        var width = doc.internal.pageSize.getWidth();

        doc.setFontSize(16);
        common.ipapi == 'https://192.168.8.109:81' || common.ipapi == 'https://api.tracky-entrepot.com'
            ? doc.addImage(common.logo, 'png', 10, 6, 30, 30)
            : doc.addImage(common.logo1, 'png', 10, 6, 30, 30);
        doc.setFontSize(12);
        doc.setFillColor(225, 206, 154);
        doc.rect(40, 15, width - 55, 10, 'F');
        doc.setTextColor(0, 0, 0);
        doc.text('LISTE DES VALEURS DU STOCK', 50, 22);
        doc.setTextColor(0, 0, 0);

        doc.autoTable({
            styles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                cellPadding: 0.75,
                halign: 'center',
                lineColor: [0, 0, 0],
                fontSize: 9
            },
            columnStyles: {
                0: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                1: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                2: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                3: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                4: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                }
            },
            theme: 'grid',
            startY: 35,
            fontSize: 9,
            head: [['Ordre', 'Quantité', 'Valeur stock', 'Valeur vente', 'Date']],
            body: data
        });
        const pageCount = doc.internal.getNumberOfPages();

        for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text('Page ' + String(i) + ' sur ' + String(pageCount), 210 - 18, 292, null, null, 'right');
        }
        doc.save('article-valeur-stock.pdf');
    }

    async function printListeCogs() {
        // setLoad(true)
        if (!dataCogs.valeur_debut) {
            return;
        }
        const data = [];
        data.push([
            { content: 'Stock initial (Valeur au début de la période)' },
            { content: numberformat(dataCogs.valeur_debut).replaceAll('.', ' ') }
        ]);
        data.push([
            { content: 'Stock  final (Valeur à la fin de la période)' },
            { content: numberformat(dataCogs.valeur_fin).replaceAll('.', ' ') }
        ]);
        data.push([{ content: 'Achats (Pendant la période)' }, { content: numberformat(dataCogs.total_achats).replaceAll('.', ' ') }]);
        data.push([
            { content: "Chiffre d'affaires (Pièces vendues)" },
            { content: numberformat(dataCogs.total_ventes).replaceAll('.', ' ') }
        ]);
        data.push([{ content: 'COGS (Coût des marchandises vendues)' }, { content: numberformat(dataCogs.cogs).replaceAll('.', ' ') }]);
        data.push([
            { content: 'Marge brute', styles: { fontStyle: 'bold', fontSize: 12 } },
            { content: numberformat(dataCogs.margebrute).replaceAll('.', ' '), styles: { fontStyle: 'bold', fontSize: 12 } }
        ]);
        const doc = new jsPDF();
        var width = doc.internal.pageSize.getWidth();

        doc.setFontSize(16);
        common.societe === 0 ? doc.addImage(common.logo, 'png', 10, 6, 30, 30) : doc.addImage(common.logo1, 'png', 10, 6, 30, 30);
        doc.setFontSize(12);
        doc.setFillColor(225, 206, 154);
        doc.rect(40, 15, width - 55, 10, 'F');
        doc.setTextColor(0, 0, 0);
        doc.text('COGS ET MARGE BRUTE', 50, 22);
        doc.setTextColor(0, 0, 0);
        doc.text(
            'Période du ' + dateformat(dataCogs.startDate, 'dd-mm-yyyy HH:MM') + ' au ' + dateformat(dataCogs.endDate, 'dd-mm-yyyy HH:MM'),
            30,
            35
        );
        doc.autoTable({
            styles: {
                fillColor: [0, 0, 0],
                textColor: [255, 255, 255],
                cellPadding: 0.75,
                halign: 'center',
                lineColor: [0, 0, 0],
                fontSize: 10
            },
            columnStyles: {
                0: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 10
                },
                1: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 10
                }
            },
            theme: 'grid',
            startY: 40,
            fontSize: 9,
            head: [['Désigantion', 'Valeur']],
            body: data
        });
        const pageCount = doc.internal.getNumberOfPages();

        for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text('Page ' + String(i) + ' sur ' + String(pageCount), 210 - 18, 292, null, null, 'right');
        }
        doc.save('cogs-mb.pdf');
    }

    //--------------- EXPORT VERS EXCEL ------------------

    const exportToExcel = async () => {
        const raw_data = gridRef.current.data.sort(GetSortOrder('created_at'));
        const rows = raw_data.map((row, index) => ({
            Ordre: index + 1,
            qtestock: numberformat(row.qtestock),
            valeurachat: numberformat(row.valeurachat),
            valeurvente: numberformat(row.valeurvente),
            created_at: row.created_at ? dateformat(row.created_at, 'dd-mm-yyyy HH:MM') : 'Néant'
        }));
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Mon stock');
        XLSX.utils.sheet_add_aoa(worksheet, [['Ordre', 'Quantité', 'Valeur stock', 'Valeur vente', 'Date']], { origin: 'A1' });
        const max_width = rows.reduce((w, r) => Math.max(w, r.created_at.length), 10);
        worksheet['!cols'] = [{ wch: max_width }];
        XLSX.writeFile(workbook, 'article-valeur-stock.xlsx');
    };

    async function saveAsExcel() {
        exportToExcel();
    }

    async function Cogs(values) {
        try {
            setLoad(true);
            var formData = new FormData();
            formData.append('datedebut', values.datedebut);
            formData.append('datefin', values.datefin);
            formData.append('societe', common.societe);
            await Axios.post(common.ipapi + '/api/article/cogs', formData, common.tok)
                .then((res) => {
                    setLoad(false);
                    if (res.data.status) {
                        setCogsData(res.data.datas);
                    } else {
                        setCogsData({
                            valeur_debut: 0,
                            valeur_fin: 0,
                            total_ventes: 0,
                            total_achats: 0,
                            cogs: 0,
                            margebrute: 0,
                            startDate: '',
                            endDate: ''
                        });
                    }
                })
                .catch((error) => {});
        } catch (error) {
            setLoad(false);
            console.error(error);
        }
    }

    function CogsDataShow({ data }) {
        return (
            <ListGroup as="ul" numbered>
                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                        <div className="fw-bold">Stock initial </div>
                        Valeur au début de la période
                    </div>
                    <Badge bg="dark" pill>
                        {numberformat(data.valeur_debut || 0).replaceAll('.', ' ')}
                    </Badge>
                </ListGroup.Item>
                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                        <div className="fw-bold">Stock final</div>
                        Valeur à la fin de la période
                    </div>
                    <Badge bg="dark" pill>
                        {numberformat(data.valeur_fin || 0).replaceAll('.', ' ')}
                    </Badge>
                </ListGroup.Item>
                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                        <div className="fw-bold">Achats</div>
                        Pendant la période
                    </div>
                    <Badge bg="dark" pill>
                        {numberformat(data.total_achats || 0).replaceAll('.', ' ')}
                    </Badge>
                </ListGroup.Item>
                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                        <div className="fw-bold">Chiffre d'affaires</div>
                        Pièces vendues
                    </div>
                    <Badge bg="dark" pill>
                        {numberformat(data.total_ventes || 0).replaceAll('.', ' ')}
                    </Badge>
                </ListGroup.Item>
                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                        <div className="fw-bold">COGS</div>
                        Coût des marchandises vendues
                    </div>
                    <Badge bg="dark" pill>
                        {numberformat(data.cogs || 0).replaceAll('.', ' ')}
                    </Badge>
                </ListGroup.Item>
                <ListGroup.Item variant="success" as="li" className="d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                        <div className="fw-bold">Marge brute</div>
                    </div>
                    <Badge bg="success" pill>
                        {numberformat(data.margebrute || 0).replaceAll('.', ' ')}
                    </Badge>
                </ListGroup.Item>
            </ListGroup>
        );
    }

    return (
        <div>
            <Navbar expand="lg" bg="light" variant="light">
                <Container>
                    <Navbar.Brand href="#/admin/articles">Historique des valeurs du stock</Navbar.Brand>
                    <Nav className="me-auto">
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-disabled">Exporter vers Excel</Tooltip>}>
                            <Nav.Link title="Exporter vers excel" onClick={() => saveAsExcel()}>
                                <FileExcel color="#088d5a" size={25} /> Excel
                            </Nav.Link>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-disabled">Exporter vers pdf</Tooltip>}>
                            <Nav.Link onClick={() => printListe()} title="Exporter vers pdf">
                                <Printer color="#0080ff" size={25} /> Imprimer
                            </Nav.Link>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-disabled">Exporter vers pdf</Tooltip>}>
                            <Nav.Link onClick={() => printListeCogs()} title="Exporter vers pdf">
                                <Printer color="#0080ff" size={25} /> Imprimer COGS
                            </Nav.Link>
                        </OverlayTrigger>
                    </Nav>
                    <Nav></Nav>
                </Container>
            </Navbar>
            <Row>
                <Col md={6}>
                    <br></br>
                    <Card>
                        <Card.Body>
                            <ReactDataGrid
                                idProperty="id"
                                handle={setGridRef}
                                style={gridStyle}
                                loading={isLoading}
                                reorderColumns={false}
                                pagination
                                pageSizes={[200, 400, 600, 800, rows.length]}
                                defaultLimit={400}
                                showHoverRows={true}
                                editable={true}
                                showColumnMenuTool={false}
                                defaultFilterValue={filterValue}
                                columns={columns}
                                dataSource={rows}
                            />
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <br></br>
                    <Card>
                        <Card.Body>
                            <Formik
                                initialValues={{
                                    datedebut: '',
                                    datefin: ''
                                }}
                                // enableReinitialize
                                validationSchema={Yup.object().shape({
                                    datedebut: Yup.date().required(common.msg).nullable(),
                                    datefin: Yup.date().required(common.msg).min(
                                        Yup.ref('datedebut'), // Référence la valeur du champ 'datedebut'
                                        'La date de fin doit être supérieure à la date de début.' // Message d'erreur personnalisé
                                    )
                                })}
                                onSubmit={async (values) => {
                                    try {
                                        Cogs(values);
                                    } catch (err) {
                                        // setMsg('Une erreur à eu lieu');
                                        // setMsgravity('danger');
                                        // setIsSave(true);
                                        // setLoad(false);
                                    }
                                }}
                            >
                                {({ errors, handleBlur, handleChange, handleSubmit, setFieldValue, setFieldTouched, values }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Navbar className="bg-body-tertiary justify-content-between">
                                            <Row>
                                                <Col md="5">
                                                    <Form.Group as={Row} className="mb-3">
                                                        <Form.Label column sm={4}>
                                                            Début:
                                                        </Form.Label>
                                                        <Col sm={8}>
                                                            <Form.Control
                                                                id="datedebut"
                                                                type="date"
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                size="sm"
                                                                value={values.datedebut}
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                    {errors.datedebut && <div id="feedback">{errors.datedebut}</div>}
                                                </Col>
                                                <Col md="5">
                                                    <Form.Group as={Row} className="mb-3">
                                                        <Form.Label column sm={2}>
                                                            Fin:
                                                        </Form.Label>
                                                        <Col sm={8}>
                                                            <Form.Control
                                                                id="datefin"
                                                                type="date"
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                size="sm"
                                                                value={values.datefin}
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                            />
                                                        </Col>
                                                        {errors.datefin && <div id="feedback">{errors.datefin}</div>}
                                                    </Form.Group>
                                                </Col>
                                                <Col md="1">
                                                    <Button color="danger" type="submit">
                                                        <Search color="#000" size={15} />
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Navbar>
                                    </Form>
                                )}
                            </Formik>

                            {dataCogs.valeur_debut ? (
                                <ListGroup>
                                    <ListGroup.Item variant="primary">
                                        Période du {dateformat(dataCogs.startDate, 'dd-mm-yyyy HH:MM')} au{' '}
                                        {dateformat(dataCogs.endDate, 'dd-mm-yyyy HH:MM')}
                                    </ListGroup.Item>
                                </ListGroup>
                            ) : (
                                <></>
                            )}
                            {dataCogs.valeur_debut ? <CogsDataShow data={dataCogs} /> : <></>}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default MyAwesomeTable;
